import * as ApiNames from './ApiNames';
const VersionNumbers = {
  [ApiNames.ADS_LIMIT_INCREASE]: {},
  [ApiNames.API_LIMIT_INCREASE]: {},
  [ApiNames.BRAZIL_ONBOARDING]: {},
  [ApiNames.BRAND_DOMAIN]: {},
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_100]: {},
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_1000]: {},
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_10000]: {},
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: {},
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: {},
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: {},
  [ApiNames.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100]: {},
  [ApiNames.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000]: {},
  [ApiNames.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000]: {},
  [ApiNames.CALCULATED_PROPERTIES_LIMIT_INCREASE]: {},
  [ApiNames.CALLING_LIMIT_INCREASE]: {},
  [ApiNames.CMS_HUB_ENTERPRISE]: {
    LATEST: 4,
    LATEST_PRESEATS: 3
  },
  [ApiNames.CMS_HUB_ENTERPRISE_ONBOARDING]: {},
  [ApiNames.CMS_HUB_FREE]: {},
  [ApiNames.CMS_HUB_PROFESSIONAL]: {
    LATEST: 12,
    LATEST_PRESEATS: 11
  },
  [ApiNames.CMS_HUB_PROFESSIONAL_ONBOARDING]: {},
  [ApiNames.CMS_HUB_STARTER]: {
    LATEST: 7,
    LATEST_PRESEATS: 6
  },
  [ApiNames.CORE_SEATS_ENTERPRISE]: {
    SMART_CRM: 2,
    LATEST: 2
  },
  [ApiNames.CORE_SEATS_INCLUDED_STARTER]: {},
  [ApiNames.CORE_SEATS_PROFESSIONAL]: {
    SMART_CRM: 2,
    LATEST: 2
  },
  [ApiNames.CORE_SEATS_STARTER]: {},
  [ApiNames.CRM_CONTACT_RECORDS_LIMIT_INCREASE]: {},
  [ApiNames.CRM_OBJECT_LIMIT_INCREASE]: {},
  [ApiNames.CRM_SUITE_ENTERPRISE_BUNDLE]: {
    LATEST: 2
  },
  [ApiNames.CRM_SUITE_PROFESSIONAL_BUNDLE]: {
    LATEST: 2
  },
  [ApiNames.CRM_SUITE_STARTER_BUNDLE]: {
    LATEST: 3
  },
  [ApiNames.CUSTOM_OBJECTS_LIMIT_INCREASE]: {},
  [ApiNames.CUSTOM_PROPERTIES_LIMIT_INCREASE]: {},
  [ApiNames.CUSTOM_SSL]: {},
  [ApiNames.DEDICATED_IP]: {
    LEGACY: 1,
    EARLY_2020: 3
  },
  [ApiNames.DOMAINS_LIMIT_INCREASE]: {},
  [ApiNames.ESIGNATURES_LIMIT_INCREASE]: {},
  [ApiNames.ESIGNATURE_LIMIT_INCREASE]: {},
  [ApiNames.FIRST_FULL_TIME_MIGRATION]: {},
  [ApiNames.HUBSPOT_FOR_STARTUPS_SETUP]: {},
  [ApiNames.HUBSPOT_FREE]: {},
  [ApiNames.INBOUND_CONSULTING_ADVANCED]: {},
  [ApiNames.INBOUND_CONSULTING_PREMIUM]: {},
  [ApiNames.LISTS_LIMIT_INCREASE]: {},
  [ApiNames.MARKETING_HUB_BASIC]: {},
  [ApiNames.MARKETING_HUB_ENTERPRISE]: {
    LATEST: 15,
    LATEST_PRESEATS: 14,
    MARKETING_CONTACTS: 12
  },
  [ApiNames.MARKETING_HUB_ENTERPRISE_ONBOARDING]: {},
  [ApiNames.MARKETING_HUB_FREE]: {},
  [ApiNames.MARKETING_HUB_PROFESSIONAL]: {
    LATEST: 15,
    LATEST_PRESEATS: 14,
    MARKETING_CONTACTS: 12
  },
  [ApiNames.MARKETING_HUB_PROFESSIONAL_ONBOARDING]: {},
  [ApiNames.MARKETING_HUB_STARTER]: {
    LATEST: 8,
    LATEST_PRESEATS: 7,
    LEGACY_250: 2,
    NOV_2019: 3,
    MARKETING_CONTACTS: 4
  },
  [ApiNames.MARKETING_HUB_STARTER_ONBOARDING]: {},
  [ApiNames.MARKETING_PLUS_ENTERPRISE_BUNDLE]: {
    LATEST: 1,
    LATEST_PRESEATS: 2
  },
  [ApiNames.MARKETING_PLUS_PROFESSIONAL_BUNDLE]: {
    LATEST: 1,
    LATEST_PRESEATS: 2
  },
  [ApiNames.MARKETING_SMS_ADDON]: {},
  [ApiNames.MARKETING_SMS_LIMIT_INCREASE]: {},
  [ApiNames.MARKETING_SMS_SHORT_CODE]: {},
  [ApiNames.ONBOARDING_FOUNDATIONS]: {},
  [ApiNames.HUBSPOT_ACADEMY_GUIDED_ONBOARDING]: {},
  [ApiNames.OPERATIONS_HUB_ENTERPRISE]: {
    LATEST: 2,
    LATEST_PRESEATS: 1
  },
  [ApiNames.OPERATIONS_HUB_FREE]: {},
  [ApiNames.OPERATIONS_HUB_PROFESSIONAL]: {
    LATEST: 2,
    LATEST_PRESEATS: 1
  },
  [ApiNames.OPERATIONS_HUB_STARTER]: {
    LATEST: 3,
    LATEST_PRESEATS: 1
  },
  [ApiNames.PHONE_LIMIT_INCREASE]: {},
  [ApiNames.PREMIUM_CONSULTING]: {},
  [ApiNames.REPORTING_LIMIT_INCREASE]: {},
  [ApiNames.SALES_HUB_ENTERPRISE]: {
    LATEST: 3,
    LATEST_PRESEATS: 1,
    QUANTIFIABLE_SEAT: 3
  },
  [ApiNames.SALES_HUB_ENTERPRISE_ONBOARDING]: {},
  [ApiNames.SALES_HUB_FREE]: {},
  [ApiNames.SALES_HUB_PROFESSIONAL]: {
    LATEST: 7,
    LATEST_PRESEATS: 5,
    LEGACY_BUSINESS_USER: 3,
    QUANTIFIABLE_SEAT: 7
  },
  [ApiNames.SALES_HUB_PROFESSIONAL_ONBOARDING]: {},
  [ApiNames.SALES_HUB_STARTER]: {
    LATEST: 5,
    LATEST_PRESEATS: 3,
    LEGACY: 1,
    MARCH_2020: 3
  },
  [ApiNames.SALES_HUB_STARTER_ONBOARDING]: {},
  [ApiNames.SANDBOX_LIMIT_INCREASE]: {},
  [ApiNames.SERVICE_HUB_ENTERPRISE]: {
    LATEST: 3,
    LATEST_PRESEATS: 1,
    QUANTIFIABLE_SEAT: 3
  },
  [ApiNames.SERVICE_HUB_ENTERPRISE_ONBOARDING]: {},
  [ApiNames.SERVICE_HUB_FREE]: {},
  [ApiNames.SERVICE_HUB_PROFESSIONAL]: {
    LATEST: 2,
    LATEST_PRESEATS: 1,
    QUANTIFIABLE_SEAT: 2
  },
  [ApiNames.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: {},
  [ApiNames.SERVICE_HUB_STARTER]: {
    LATEST: 4,
    LATEST_PRESEATS: 2,
    LEGACY: 1,
    MARCH_2020: 2
  },
  [ApiNames.SERVICE_HUB_STARTER_ONBOARDING]: {},
  [ApiNames.STARTER_KIT]: {},
  [ApiNames.STRATEGIC_CONSULTING_4_HOUR]: {},
  [ApiNames.STRATEGIC_CONSULTING_MONTHLY]: {},
  [ApiNames.STRATEGIC_CONSULTING_ONGOING]: {},
  [ApiNames.TEAMS_LIMIT_INCREASE]: {},
  [ApiNames.TECHNICAL_CONSULTING_4_HOUR]: {},
  [ApiNames.TECHNICAL_CONSULTING_ADVANCED]: {},
  [ApiNames.TECHNICAL_CONSULTING_ONGOING]: {},
  [ApiNames.TECHNICAL_CONSULTING_PREMIUM]: {},
  [ApiNames.TRAINING_AGENCY_MARKETING_HUB_FUNDAMENTALS]: {},
  [ApiNames.TRANSACTIONAL_EMAIL]: {},
  [ApiNames.TRANSCRIPTION_LIMIT_INCREASE]: {},
  [ApiNames.USERS_LIMIT_INCREASE]: {},
  [ApiNames.VIDEO_LIMIT_INCREASE]: {},
  [ApiNames.WHATSAPP_LIMIT_INCREASE]: {},
  [ApiNames.WORKFLOWS_LIMIT_INCREASE]: {},
  [ApiNames.HUBSPOT_CREDITS_COMMITTED]: {},
  [ApiNames.HUBSPOT_CREDITS_COMMITTED_OVERAGE]: {},
  [ApiNames.HUBSPOT_CREDITS_OVERAGE]: {},
  [ApiNames.COMMERCE_HUB_PROFESSIONAL]: {},
  [ApiNames.COMMERCE_HUB_ENTERPRISE]: {},
  [ApiNames.COMMERCE_HUB_FREE]: {},
  [ApiNames.ADVANCED_ONBOARDING]: {},
  [ApiNames.ADVANCED_ONBOARDING_MIGRATION_SERVICES]: {},
  [ApiNames.AGENCY_PIPELINE_GENERATION_TRAINING_PLUS]: {},
  [ApiNames.AGENCY_SALES_SKILLS_TRAINING_PLUS]: {},
  [ApiNames.ASSET_MIGRATION_BASE]: {},
  [ApiNames.ASSET_MIGRATION_PREMIUM]: {},
  [ApiNames.BASIC_DESIGNATED_ACCOUNT_SERVICES]: {},
  [ApiNames.BLOG_MIGRATION]: {},
  [ApiNames.BREEZE_INTELLIGENCE_BACKFILL_ENRICHMENT]: {},
  [ApiNames.BREEZE_INTELLIGENCE_BULK_ENRICHMENT]: {},
  [ApiNames.BUSINESS_UNIT_EXTENSION]: {},
  [ApiNames.CREATING_EFFECTIVE_INBOUND_CONTENT_TRAINING]: {},
  [ApiNames.CRM_DATA_MIGRATION]: {},
  [ApiNames.CRM_SUITE_ONBOARDING_ENTERPRISE]: {},
  [ApiNames.CRM_SUITE_ONBOARDING_PREMIER]: {},
  [ApiNames.CRM_SUITE_ONBOARDING_PROFESSIONAL]: {},
  [ApiNames.CRM_TRAINING]: {},
  [ApiNames.CUSTOM_CLASSROOM_TRAINING]: {},
  [ApiNames.CUSTOM_CONSULTING]: {},
  [ApiNames.DATA_MIGRATION_CONSULTING]: {},
  [ApiNames.DATA_WAREHOUSE]: {},
  [ApiNames.EMAIL_TEMPLATE_SETUP]: {},
  [ApiNames.ENTERPRISE_EDUCATION_PROGRAM]: {},
  [ApiNames.ENTERPRISE_SUITE_ONBOARDING]: {},
  [ApiNames.EXECUTIVE_SUMMIT_HOW_HUBSPOT_BUILT_ITS_SALES_AND_MARKETING_MACHINE]: {},
  [ApiNames.FIRST_TIME_BLOG_MIGRATION]: {},
  [ApiNames.FRIENDS_AND_FAMILY]: {},
  [ApiNames.FULL_MIGRATION]: {},
  [ApiNames.GOLD_CRM_DATA_MIGRATION]: {},
  [ApiNames.GRANTED_CORE_SEATS]: {},
  [ApiNames.HUBSPOT_CRM_DATA_MIGRATION]: {},
  [ApiNames.HUBSPOT_IMPLEMENTATION_CONSULTING]: {},
  [ApiNames.IMPLEMENTATION_FEE_20K]: {},
  [ApiNames.INBOUND_CONSULTING_FOR_PARTNERS]: {},
  [ApiNames.INBOUND_CONSULTING_NEW_USER_TRAINING]: {},
  [ApiNames.INBOUND_SUCCESS_CONTENT_ADVANTAGE]: {},
  [ApiNames.INBOUND_SUCCESS_NON_PROFIT_ADVANTAGE]: {},
  [ApiNames.INDUSTRY_BUSINESS_CONSULTING_ONGOING]: {},
  [ApiNames.INDUSTRY_TECHNICAL_CONSULTING_ONGOING]: {},
  [ApiNames.INTEGRATION_SUPPORT]: {},
  [ApiNames.LARGE_SERVICES]: {},
  [ApiNames.LEAD_MANAGEMENT_AND_AUTOMATION_TRAINING]: {},
  [ApiNames.LEGACY_MARKETING]: {},
  [ApiNames.LEGACY_SALES_HUB_PROFESSIONAL_LIMITS]: {},
  [ApiNames.MARKETING_HUB_ADVANCED_ONBOARDING]: {},
  [ApiNames.MARKETING_HUB_ATTRACT_LEADS_TRAINING]: {},
  [ApiNames.MARKETING_HUB_BASIC_ONBOARDING]: {},
  [ApiNames.MARKETING_HUB_ENTERPRISE_LEGACY_FEATURES]: {},
  [ApiNames.MARKETING_HUB_ENTERPRISE_ONBOARDING_LATAM]: {},
  [ApiNames.MARKETING_HUB_GENERATE_LEADS_TRAINING]: {},
  [ApiNames.MARKETING_HUB_HANDOFF_LEADS_TRAINING]: {},
  [ApiNames.MARKETING_HUB_NURTURE_LEADS_TRAINING]: {},
  [ApiNames.MARKETING_HUB_PROFESSIONAL_ONBOARDING_LATAM]: {},
  [ApiNames.MIGRATE_THEME]: {},
  [ApiNames.MIGRATE_THEME_CONTENT_MIGRATION]: {},
  [ApiNames.MIGRATION_CONSULTING_4_HOUR]: {},
  [ApiNames.MULTIPLE_PREMIERE_ONBOARDING]: {},
  [ApiNames.NETSUITE_UPDATE_TEST]: {},
  [ApiNames.ONBOARDING_EXTENSION_4_HOUR]: {},
  [ApiNames.ONE_TIME_CREDIT]: {},
  [ApiNames.ONE_TIME_INBOUND_CONSULTING_FOR_PARTNERS]: {},
  [ApiNames.ONE_TIME_TECHNICAL_CONSULTING_FOR_PARTNERS]: {},
  [ApiNames.ONSITE_ONBOARDING]: {},
  [ApiNames.PARTNER_20K_IMPLEMENTATION_FEE]: {},
  [ApiNames.PARTNER_ONBOARDING]: {},
  [ApiNames.PARTNER_ONBOARDING_FOUNDATIONS]: {},
  [ApiNames.PARTNER_PIPELINE_GENERATION_BOOTCAMP_PRO_TRAINING]: {},
  [ApiNames.PARTNER_PRIVATE_CUSTOMER_TRAINING_BASE]: {},
  [ApiNames.PARTNER_PRIVATE_CUSTOMER_TRAINING_BASE_ONSITE]: {},
  [ApiNames.PARTNER_PRIVATE_TRAINING_PREMIUM]: {},
  [ApiNames.PARTNER_SALES_SKILLS_BOOTCAMP_PRO_TRAINING]: {},
  [ApiNames.PARTNER_TECHNICAL_ACCELERATOR]: {},
  [ApiNames.PAST_DUE_AMOUNT]: {},
  [ApiNames.PREMIUM_SUPPORT]: {},
  [ApiNames.PREMIUM_SUPPORT_SKU]: {},
  [ApiNames.PRIVATE_CUSTOMER_TRAINING_BASE]: {},
  [ApiNames.PRIVATE_CUSTOMER_TRAINING_BASE_ONSITE]: {},
  [ApiNames.PRIVATE_TRAINING_BASE]: {},
  [ApiNames.PRIVATE_TRAINING_PREMIUM]: {},
  [ApiNames.PROFESSIONAL_SUITE_ONBOARDING]: {},
  [ApiNames.QUICK_START_CONSULTATION]: {},
  [ApiNames.REFUND]: {},
  [ApiNames.REMOTE_TEAM_TRAINING]: {},
  [ApiNames.REOPEN_PORTAL]: {},
  [ApiNames.REPORTING_ADD_ON_TRAINING]: {},
  [ApiNames.SALES_AND_MARKETING_ALIGNMENT]: {},
  [ApiNames.SALES_HUB_ADVANCED_ONBOARDING]: {},
  [ApiNames.SALES_HUB_AUTOMATION_TRAINING]: {},
  [ApiNames.SALES_HUB_CONFIGURE_YOUR_DEAL_PIPELINE_TRAINING]: {},
  [ApiNames.SALES_HUB_PRODUCTIVITY_TOOLS_TRAINING]: {},
  [ApiNames.SALES_HUB_REPORTING_TRAINING]: {},
  [ApiNames.SALES_SETUP]: {},
  [ApiNames.SENSITIVE_DATA]: {},
  [ApiNames.SERVICE_AVISON_YOUNG_IMPLEMENTATION]: {},
  [ApiNames.SERVICE_BLOCK_4_HOUR]: {},
  [ApiNames.SERVICE_BLOCK_8_HOUR]: {},
  [ApiNames.SERVICE_HUB_FUNDAMENTALS]: {},
  [ApiNames.SERVICE_SMS]: {},
  [ApiNames.SILVER_CRM_DATA_MIGRATION]: {},
  [ApiNames.STRATEGIC_CONSULTING_1_DAY]: {},
  [ApiNames.TECH_SERVICE_FIRST_TIME_TEMPLATE_SETUP]: {},
  [ApiNames.TECH_SERVICE_TEMPLATE_SETUP]: {},
  [ApiNames.TECHNICAL_CONSULTING_1_DAY]: {},
  [ApiNames.TECHNICAL_CONSULTING_OPERATIONS_HUB_DATASYNC]: {},
  [ApiNames.TECHNICAL_CONSULTING_OPERATIONS_HUB_PROGRAMMABLE_AUTOMATION]: {},
  [ApiNames.TECHNICAL_CONSULTING_PARTNERS]: {},
  [ApiNames.TRAINING_AGENCY_ACCOUNT_MANAGEMENT_ESSENTIALS]: {},
  [ApiNames.TRAINING_AGENCY_CRM_MANAGEMENT]: {},
  [ApiNames.TRAINING_BUILDING_AN_INBOUND_CAMPAIGN_FUNDAMENTALS]: {},
  [ApiNames.TRAINING_OPTIMIZING_YOUR_SALES_WITH_HUBSPOT_CRM_TRAINING_COURSE]: {},
  [ApiNames.TRAINING_SALES_AND_MARKETING_ALIGNMENT]: {},
  [ApiNames.TRAINING_SALES_HUB_FUNDAMENTALS]: {},
  [ApiNames.UNLIMITED_CONTACTS]: {},
  [ApiNames.WEB_HOSTING_SSL_PACK]: {},
  [ApiNames.CORE_SEATS_STARTER_HSOC]: {},
  [ApiNames.CORE_SEATS_PROFESSIONAL_HSOC]: {},
  [ApiNames.CORE_SEATS_ENTERPRISE_HSOC]: {},
  [ApiNames.ENTERPRISE_FLEX_PROGRAM]: {},
  [ApiNames.FLEX_SEAT]: {},
  [ApiNames.CORE_SEATS_INCLUDED_STARTER_HSOC]: {},
  [ApiNames.FRONT_OFFICE_SEATS_ENTERPRISE_HSOC]: {},
  [ApiNames.FRONT_OFFICE_SEATS_PROFESSIONAL_HSOC]: {},
  [ApiNames.SOLUTIONS_PARTNER_PROGRAM]: {}
};
export default VersionNumbers;